import { FormItems, Spec } from "src/app/services/api/masterdata/masterdata.service";

export class FormItemObject implements FormItems{
    hjid: string;
    value: string;
    description: string;
    specId: Spec;
}